import React, { useState } from "react";
import { Box, Slider, Typography } from "@mui/material";

export default function ZoomSlider({ onChange = (newValue, direction) => { } }) {
    const [value, setValue] = useState(60);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        onChange(newValue, (newValue - value))
    };

    return (
        <Box
            sx={{
                width: 200,
                p: 2,
                bgcolor: "#2c2c2c",
                borderRadius: 2,
                color: "#fff",
            }}
        >
            {/* Top Labels */}
            <Box display="flex" justifyContent="space-between">
                <Typography variant="caption">0%</Typography>
                <Typography variant="caption">{value}%</Typography>
                <Typography variant="caption">100%</Typography>
            </Box>

            {/* Slider */}
            <Slider
                value={value}
                onChange={handleChange}
                min={0}
                max={100}
                sx={{
                    color: "#fff",
                    mt: 0,
                    "& .MuiSlider-thumb": {
                        bgcolor: "#fff",
                    },
                    "& .MuiSlider-track": {
                        bgcolor: "#fff",
                    },
                    "& .MuiSlider-rail": {
                        bgcolor: "#aaa",
                    },
                }}
            />

            {/* Bottom Labels */}
            <Box display="flex" justifyContent="space-between" >
                <Typography variant="caption">Zoom out</Typography>
                <Typography variant="caption">Zoom in</Typography>
            </Box>
        </Box>
    );
}